<template>
  <v-dialog
    v-model="dialogState"
    v-if="newsModel"
    persistent
    max-width="1200px"
    min-height="800px"
  >
    <v-card>
      <v-toolbar color="accent" fixed>
        <v-toolbar-title>
          <v-icon left class="mt-n1">mdi-plus</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.edit") }}
        </v-toolbar-title>
      </v-toolbar>

      <div class="row" style="margin: 0px !important; justify-content: center">
        <div class="col col-md-6">
          <v-img v-if="tempImage" :src="tempImage.url" class="imgClass" />
          <v-img
            v-else-if="
              newsModel.title.img &&
              newsModel.title.img.ka &&
              newsModel.title.img.ka.url
            "
            :src="newsModel.title.img.ka.url"
            class="imgClass"
          />
          <v-file-input
            v-model="tempImage"
            show-size
            truncate-length="50"
            :placeholder="$vuetify.lang.t('$vuetify.action.change_banner')"
            accept=".jpeg,.jpg,.png"
            :loading="loading"
            @change="fileUpload"
            hint="1140 x 350"
          ></v-file-input>
          <div class="text-center font-weight-bold">1140 x 350px</div>
        </div>
      </div>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close', false, false)">
          <v-icon class="mr-3">mdi-close</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.cancel") }}
        </v-btn>
        <v-btn @click="$emit('close', newsModel, tempImage)">
          <v-icon class="mr-3">mdi-content-save</v-icon>
          {{ $vuetify.lang.t("$vuetify.action.add") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from "@/services/api";
export default {
  data: function () {
    return {
      dialogState: false,
      tempImage: false,
      loading: false,
    };
  },
  methods: {
    fileUpload(file) {
      if (!file) {
        return;
      }
      this.loading = true;
      const formData = new FormData();
      formData.append("file", file);
      Api.media("upload", formData)
        .then(({ data }) => {
          this.$toast.ok(this.$vuetify.lang.t("$vuetify.manager.imported"));
          this.tempImage = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    newsImagePopup(newVal) {
      this.dialogState = newVal;
      this.loading = false;
      this.tempImage = false;
    },
  },
  props: ["newsImagePopup", "newsModel"],
};
</script>
<style lang="css" scoped>
.imgClass {
  max-width: 100%;
  max-height: 56%;
  width: 100%;
  height: 56%;
}
</style>
